export default __webpack_public_path__ + "static/media/nfe_icon.03488a65.png";